export default {
  "leadConvertedAndMemberCreated": "prospect converti et membre créé",
  "members": "Membres",
  "thisMemberDoesNotHaveAPhoneNumberOnFile": "Ce membre n'a pas de numéro de téléphone au dossier.",
  "pleaseSelectAClubInstanceFromTheTopRightSwitcherToManageMembers": "Veuillez sélectionner une instance de club depuis le commutateur supérieur droit pour gérer les membres.",
  "importMembers": "Membres d ' importation",
  "addMember": "Ajouter un membre",
  "searchMembers": "Rechercher des membres...",
  "noMembersFound": "Aucun membre trouvé",
  "deleteMember": "Supprimer le membre",
  "thisActionCannotBeUndone": "Cette action ne peut être annulée.",
  "areYouSureYouWantToDelete": "Êtes-vous sûr que vous voulez supprimer",
  "thisWillPermanentlyRemoveTheirMembershipRecordAndAllAssociatedData": "? Cela supprimera définitivement leur dossier d'adhésion et toutes les données associées.",
  "deleting": "Supprimer...",
  "describeTheMessageYouWantToSendAndILlWriteItForYouYouCanTypeOrUseYourVoice": "Décrivez le message que vous voulez envoyer, et je l'écrirai pour vous. Vous pouvez taper ou utiliser votre voix.",
  "eGWriteAFriendlyFollowUpAboutTheMemberDinnerNextFridayAndAskIfTheyHaveAnyDietaryRestrictions": "Par exemple, « Écrire un suivi amical sur le dîner membre vendredi prochain et demander s'ils ont des restrictions alimentaires. »",
  "stopListening": "Arrête d'écouter.",
  "useVoice": "Utiliser la voix",
  "generateMessage": "Générer un message",
  "member": "Membre",
  "sorryIWasUnableToGenerateAMessagePleaseTryAgain": "Désolé, j'ai été incapable de générer un message.",
  "makeCall": "Appelle-moi.",
  "contactMember": "Contacteur",
  "failedToSendMessage": "N'a pas envoyé de message",
  "lead": "Prospect",
  "message": "Message",
  "willSendViaYourConnectedEmailProviderGmailOutlook": "Enverra par l'intermédiaire de votre fournisseur d'e-mail connecté (Gmail/Outlook)",
  "aiSuggestedReplies": "AI Réponses suggérées",
  "generatingIdeas": "Générer des idées...",
  "messageSentSuccessfully": "Message envoyé avec succès!",
  "call": "Appeler",
  "loadingActivityHistory": "Chargement de l'histoire de l'activité...",
  "noActivityHistoryRecordedYet": "Aucune histoire d'activité n'a encore été enregistrée.",
  "activity": "Activité",
  "reciprocalVisit": "Visite réciproque",
  "unknown": "Inconnu",
  "noSmsInteractionsYet": "Aucun échange SMS pour le moment.",
  "noEmailInteractionsYet": "Pas encore d'interactions e-mail.",
  "noCallInteractionsYet": "Pas encore d'interactions d'appels.",
  "noInteractionsLoggedForThisMemberYet": "Aucune interaction n'est encore enregistrée pour ce membre.",
  "openInSmsModule": "Ouvert en module SMS",
  "loadingMoreInteractions": "Charger plus d'interactions...",
  "overdue": "En retard",
  "annualDues": "Sommes annuelles :",
  "interactions": "Interactions :",
  "activities": "Activités :",
  "memberSince": "Membre depuis",
  "viewProfile": "Voir le profil",
  "callMember": "Membre de l ' appel",
  "editMember": "Modifier Member",
  "spouse": "Conjoint",
  "partner": "Partenaire",
  "parent": "Parent",
  "sibling": "Bling",
  "guardian": "Tuteur",
  "other": "Autre",
  "unableToLoadProfileGroups": "Incapable de charger des groupes de profil.",
  "vegetarian": "Végétariens",
  "vegan": "Végétalien",
  "pescatarian": "Pescataire",
  "glutenFree": "Sans gluten",
  "dairyFree": "Sans lait",
  "halal": "Halal",
  "kosher": "Casher",
  "nutAllergy": "Allergie aux nus",
  "otherAllergy": "Autres allergies",
  "otherRequirement": "Autres prescriptions",
  "preferredTitle": "Titre privilégié",
  "firstName": "Prénom",
  "middleNames": "Noms moyens",
  "lastName": "Nom",
  "preferredName": "Nom privilégié",
  "gender": "Genre",
  "dateOfBirth": "Date de naissance",
  "maritalStatus": "Situation matrimoniale",
  "anniversary": "Anniversaire",
  "signInEmail": "E-mail sign-in",
  "readOnlyAccountEmail": "E-mail de compte simple",
  "contactEmail": "E-mail de contact",
  "secondaryEmail": "Courriel secondaire",
  "mobile": "Mobile",
  "homeTelephone": "Téléphone à domicile",
  "workTelephone": "Téléphone de travail",
  "personal": "Personnel",
  "profile": "Profil",
  "contact": "Contact",
  "addresses": "Adresses",
  "emergency": "Urgence",
  "family": "Famille",
  "dietary": "Régime alimentaire",
  "vehicles": "des véhicules",
  "unableToLoadActivityDetails": "Incapable de charger les détails de l'activité",
  "pleaseChooseAnInteractionType": "Veuillez choisir un type d'interaction.",
  "unableToSaveInteraction": "Incapable de Enregistrer l'interaction",
  "failedToAddInteraction": "N'ayant pas ajouté d'interaction",
  "backToMembers": "Retour aux Membres",
  "memberNotFound": "Un membre n'a pas trouvé.",
  "golfBooking": "Réservation de golf",
  "racquetBooking": "Réservation racquet",
  "fitnessClass": "Classe de condition physique",
  "spaBooking": "Réservation de spa",
  "reciprocalClubVisit": "Visite du club réciproque",
  "roomReservation": "Réservation de chambre",
  "eventAttendance": "Participation à l'événement",
  "activityDetails": "Détails de l'activité",
  "unknownMember": "Membre inconnu",
  "viewProfilePicture": "Voir la photo de profil",
  "phone": "Téléphone",
  "membershipNumber": "Numéro d ' adhésion",
  "annualDues2": "Sommes dues annuelles",
  "weddingDate": "Date de mariage",
  "anniversary2": "Anniversaire :",
  "address": "Adresse",
  "emergencyContact": "Contact de secours",
  "loadingFamilyMembers": "Chargement des membres de la famille...",
  "noLinkedFamilyMembers": "Aucun membre de la famille lié.",
  "boats": "Bateaux",
  "boat": "Bateau",
  "horses": "Chevaux",
  "horse": "Cheval",
  "sportLevels": "Niveaux de sport",
  "golfHcp": "Handicap de golf",
  "tennisLevel": "Tennis",
  "padelLevel": "Niveau de Padel",
  "visualMemberProfileCards": "Cartes de profil de membre visuel",
  "profileGroups": "Groupes de profil",
  "loading": "Chargement…",
  "primaryPostal": "Postes primaires",
  "noAddressesRecorded": "Pas d'adresses enregistrées.",
  "emergencyContact2": "Contact de secours",
  "accepted": "• Acceptée",
  "memberConsentRequests": "Demandes de consentement des membres",
  "incomingToMember": "À l ' arrivée des membres",
  "outgoingFromMember": "Échappement du membre",
  "removal": "Élimination",
  "add": "Ajouter",
  "noDietaryRequirementsRecorded": "Pas d'exigences alimentaires enregistrées.",
  "primaryVehicle": "Véhicule primaire",
  "noVehiclesRecorded": "Aucun véhicule n'a été enregistré.",
  "memberDetails": "Détails des membres",
  "crmLeadHistory": "Historique des chefs de file du CRM",
  "achievementsHistory": "Réalisations / Histoire",
  "interactions2": "(interactions)",
  "activityHistory": "Historique des activités (en anglais)",
  "financial": "financier",
  "memberInteractionHistory": "Interaction avec les membres",
  "completeRecordOfAllCommunicationsAndInteractions": "Compte rendu complet de toutes les communications et interactions",
  "filter": "Filtrer",
  "allInteractions": "Toutes les interactions",
  "all": "Tous",
  "activityHistory2": "Historique des activités",
  "loggedActivitiesForThisMember": "Activités identifiées pour ce membre",
  "bookingMemberName": "Nom du membre de réservation",
  "bookingMemberNumber": "Numéro de membre de la réservation",
  "service": "Service",
  "spaService": "Soin spa",
  "therapist": "Praticien",
  "notAssigned": "Non assigné",
  "room": "Chambre",
  "destinationClub": "Club de destination",
  "reciprocalType": "Type réciproque",
  "confirmationNumber": "Numéro de confirmation",
  "guests": "Invités",
  "checkIn": "Enregistrement",
  "checkOut": "Départ",
  "event": "Événement",
  "attendees": "Participants",
  "weCouldnTMatchThisActivityToAKnownDetailModalYet": "Nous ne pouvions pas encore correspondre à cette activité à un détail connu modal.",
  "title": "Titre:",
  "occurredAt": "S'est produite à:",
  "typeKey": "Clé de type:",
  "players": "Joueurs",
  "guest": "Invité",
  "unknownPlayer": "Le joueur inconnu",
  "hcp": "Hcp:",
  "noPlayersRecorded": "Aucun joueur n'a enregistré.",
  "addOns": "Suppléments",
  "addOn": "Supplément",
  "qty": "Qté :",
  "noAddOnsRecorded": "Pas d'add-ons enregistré.",
  "loadingTypes": "Chargement des types...",
  "noMembershipTypesFound": "Aucun type d'adhésion n'a été trouvé",
  "active": "Actif",
  "sortBy": "Trier par...",
  "newestFirst": "Le plus récent",
  "nameAZ": "Nom (A-Z)",
  "nameZA": "Nom (Z-A)",
  "membershipAsc": "Composition # (Asc)",
  "membershipDesc": "Composition # (Desc)",
  "mostInteractions": "La plupart des interactions",
  "mostActivities": "La plupart des activités",
  "inCreditBy": "Montant crédité",
  "balanceDue": "Solde dû",
  "noOverdueInvoices": "Pas de factures en retard",
  "unableToLoadFinancialData": "Impossible de charger des données financières",
  "membershipDuesStatus": "État des cotisations syndicales",
  "readOnlyDuesStatusAndRecentBillingActivity": "Le statut des cotisations simples et l'activité récente de facturation.",
  "youDonTHavePermissionToViewMemberFinancials": "Vous n’avez pas la permission de consulter les finances des membres.",
  "currentDuesStatus": "État actuel des cotisations",
  "activeTemplate": "Modèle actif",
  "notConfigured": "Non configuré",
  "nextInvoiceDate": "Date de la facture suivante",
  "outstandingDuesBalance": "Solde des cotisations exceptionnelles",
  "latestDuesInvoice": "Dernières factures",
  "noDuesInvoiceYet": "Pas de facture de fraises",
  "latestDuesInvoiceDue": "Dernières factures dues due",
  "overdueDuesInvoices": "factures en retard",
  "recentDuesPayments": "Montants récemment remboursés",
  "financialSummary": "Résumé financier",
  "memberNetPaidBalanceAndOverdueInsights": "Les membres nets payés, les soldes et les idées en retard.",
  "netPaidYtd": "YTD",
  "netPaidMtd": "MTD",
  "netPaidWtd": "WTD",
  "netPaidToday": "Montant net payé aujourd ' hui",
  "balance": "Solde",
  "latestOverdueInvoice": "Dernière facture en retard",
  "accountActivity": "Activité de compte",
  "canonicalMemberAccountChargesAndLedgerActivity": "Les frais de compte des membres canoniques et l'activité du grand livre.",
  "noMemberAccountActivityFound": "Aucune activité de compte membre n'a été trouvée.",
  "date": "Date",
  "type": "Type",
  "notRecorded": "Non enregistré",
  "payments": "Paiements",
  "mostRecentPaymentsAndAllocations": "Paiements et allocations les plus récents.",
  "noPaymentsFoundForThisMember": "Aucun paiement n'a été trouvé pour ce membre.",
  "paidAt": "Payées",
  "allocations": "Allocations",
  "allocation": "Allocations",
  "noAllocations": "Aucune allocation",
  "loadMore": "Charger plus",
  "unableToResolveClubForFamilyLinks": "Incapable de résoudre le club pour les liens familiaux",
  "unableToResolveClubForMembershipTypes": "Incapable de résoudre le club pour les types d'adhésion",
  "failedToLoadMembershipTypes": "Ne pas charger les types d'adhésion",
  "unableToSearchMembers": "Incapables aux membres de la recherche",
  "unableToDetermineClubForUpload": "Impossible de déterminer le club pour le téléchargement",
  "uploadFailed": "Chargement échouée",
  "errorClubContextIsNotAvailableCannotSaveMember": "Erreur: Le contexte du club n'est pas disponible.",
  "pleaseProvideFirstNameLastNameEmailAndMembershipNumber": "Veuillez fournir le prénom, le nom de famille, le courriel et le numéro d'adhésion.",
  "phoneNumberIsRequired": "Numéro de téléphone requis",
  "pleaseEnterAValidPhoneNumberE164": "Veuillez saisir un numéro de téléphone valide (E.164)",
  "unableToUpdateMember": "Incapable de mettre à jour le membre",
  "unableToCreateMember": "Incapable de créer un membre",
  "failedToSaveMemberPleaseTryAgain": "Vous n'avez pas réussi à Enregistrer un membre.",
  "areYouSureYouWantToDeleteThisMemberThisCannotBeUndone": "Êtes-vous sûr que vous voulez supprimer ce membre? Cela ne peut pas être fait.",
  "errorClubContextIsNotAvailableCannotDeleteMember": "Erreur: Le contexte du club n'est pas disponible.",
  "unableToDeleteMember": "Incapable de supprimer le membre",
  "failedToDeleteMemberPleaseTryAgain": "N'a pas supprimé le membre. Veuillez réessayer.",
  "unableToAddFamilyLink": "Incapable d'ajouter un lien familial",
  "unableToRemoveFamilyLink": "Incapable de supprimer le lien familial",
  "addNewMember": "Ajouter New Member",
  "enterTheDetailsForTheClubMemberBelow": "Entrez les détails pour le membre du club ci-dessous.",
  "memberAvatar": "Membre avatar",
  "uploading": "Chargement...",
  "uploadPhoto": "Télécharger la photo",
  "removePhoto": "Supprimer la photo",
  "currentMembershipTerm": "Mandat d ' admission actuel",
  "unspecified": "Non précisé",
  "started": "Démarré",
  "renewal": "; renouveau",
  "renewalDateOverrideOptional": "Renouvellement de la date (facultatif)",
  "firstName2": "Prénom",
  "lastName2": "Nom",
  "localNumber": "Numéro local",
  "enterMembershipNumber": "Entrez le numéro d'adhésion",
  "joinDate": "Joignez-vous",
  "dateOfBirth2": "Date de naissance",
  "linkRelatedMembersWithinThisClub": "Lien entre les membres associés dans ce club.",
  "saveTheMemberFirstToAddFamilyLinks": "Enregistrer le membre d'abord pour ajouter des liens familiaux.",
  "searchMembers2": "Membres de recherche",
  "typeANameOrMembershipNumber": "Taper un nom ou un numéro d'adhésion",
  "noMembershipNumber": "Pas de numéro de membre",
  "noMembersMatchThatSearch": "Aucun membre ne correspond à cette recherche.",
  "relation": "Relation",
  "linkedMembers": "Membres liés",
  "remove": "Retirer",
  "noFamilyMembersLinkedYet": "Aucun membre de la famille n'est encore lié.",
  "deleteMember2": "Supprimer le membre",
  "renewalDateOverride": "Date de renouvellement personnalisée",
  "onlyCsvFilesAreSupportedForImportPleaseUploadACsvFile": "Seulement CSV fichiers sont pris en charge pour l'importation. Veuillez télécharger un fichier .csv.",
  "currentClubContextIsMissingCannotImportMembersWithoutATenantId": "Le contexte actuel du club est absent. Les membres ne peuvent pas importer sans carte de locataire.",
  "chooseImportMethod": "Choisissez la méthode d'importation",
  "uploadExistingFile": "Télécharger fichier existant",
  "uploadACsvFileWithYourMemberData": "Téléchargez un fichier CSV avec vos données membres",
  "supportedFormatsCsv": "Formats supportés: CSV",
  "useOurTemplate": "Utilisez notre modèle",
  "downloadAPreFormattedTemplateWithSampleData": "Télécharger un modèle préformaté avec des données d'échantillon",
  "downloadTemplate": "Télécharger Template",
  "fillOutTheTemplateAndUploadItAbove": "Remplissez le modèle et téléchargez-le ci-dessus",
  "processingFile": "Fichier de traitement...",
  "mapYourFields": "Carte Vos champs",
  "matchYourDataColumnsToPrivanaFieldsRequiredFieldsAreMarkedWith": "Associez vos colonnes de données à Privana champs. Les champs obligatoires sont marqués par *",
  "selectColumn": "Sélectionnez la colonne...",
  "noMapping": "-- Aucune correspondance --",
  "back": "Retour",
  "previewImport": "Prévisualisation Importance",
  "reviewTheFirst5RowsOfYourMappedDataBeforeImporting": "Révisez les 5 premières rangées de vos données cartographiées avant d'importer",
  "members2": "membres",
  "willBeImportedPleaseVerifyThePreviewDataLooksCorrectBeforeProceeding": "sera importé. Veuillez vérifier que les données de prévisualisation sont correctes avant de procéder.",
  "backToMapping": "Retour à la cartographie",
  "startImport": "Commencer à importer",
  "importComplete": "Importation complète",
  "successfullyImported": "Importé avec succès",
  "failedToImport": "N ' importe pas",
  "errors": "Erreurs :",
  "row": "Rangée",
  "seeTheSalesInteractionsThatHappenedBeforeThisMemberJoined": "Voir les interactions de vente qui se sont produites avant que ce membre ne se joigne.",
  "loadingLeadHistory": "Charger l'histoire du prospect...",
  "unableToLoadLeadHistoryForThisMember": "Incapable de charger l'histoire du prospect pour ce membre.",
  "originallyCapturedAsCrmLead": "Initialement capturé comme chef de file CRM.",
  "noCrmInteractionsWereLoggedForThisLead": "Aucune interaction CRM n'a été enregistrée pour ce prospect.",
  "interaction": "Interaction",
  "name": "Nom",
  "membership": "Composition #",
  "associateCallRecord": "Enregistrement d'appels associés",
  "multipleMembersMatchThePhoneNumberFromTheCallWith": "Plusieurs membres correspondent au numéro de téléphone de l'appel avec",
  "unknownCaller": "Inconnu Caller",
  "pleaseSelectWhichMemberToLogThisActivityFor": ". Veuillez sélectionner le membre pour enregistrer cette activité.",
  "linkedCount": "Liés : {count}",
  "requiredMappings": "Veuillez mapper les champs obligatoires: {fields}",
  "dueInDays": "Jours avant l’échéance : {count}",
  "dueOn": "{date}",
  "years": "Années : {count}",
  "overdueDays": "Jours de retard : {count}",
  "holes": "Trous : {count}",
  "playersCount": "Joueurs : {count}",
  "onePlayer": "1 joueur",
  "parseFailed": "Incapable de parse ce CSV . Vérifiez que chaque ligne a les mêmes colonnes que l'en-tête.",
  "readFailed": "Impossible de lire ce fichier. Veuillez réessayer.",
  "preparationFailed": "Impossible de préparer cette ligne. Vérifiez ses données et son entrée.",
  "importFailed": "Impossible de compléter l'importation. Veuillez réessayer.",
  "tenure": "( {years} yr, {months} m)",
  "importFields": {
    "first_name": "Prénom",
    "last_name": "Nom",
    "email": "E-mail",
    "phone": "Téléphone",
    "membership_type": "Type de membre",
    "membership_number": "Numéro d ' adhésion",
    "membership_term_start": "Début de la période d’adhésion",
    "renewal_date_override": "Date de renouvellement personnalisée",
    "joined_at": "Date d’adhésion",
    "join_date": "Joignez-vous",
    "status": "Statut",
    "emergency_contact": "Contact de secours",
    "address": "Adresse",
    "notes": "Notes",
    "membership_type_id": "Type d ' adhésion",
    "membership_type_name": "Type d ' adhésion Nom",
    "date_of_birth": "Date de naissance"
  },
  "fieldTypes": {
    "text": "Texte",
    "email": "E-mail",
    "select": "Option",
    "date": "Date"
  },
  "child": "Enfant",
  "followUpPlaceholder": "Suivi à partir de {name} 's",
  "loadMembersFailed": "Impossible de charger les membres. Veuillez réessayer.",
  "loadingMembers": "Chargement des membres...",
  "smsRouting": {
    "inbound_member_priority_alpha": {
      "label": "Autorouted: Priorité des membres",
      "tooltip": "Ce numéro de téléphone correspond à plusieurs personnes dans Privana . Ce SMS entrant a été auto-acheminé à ce membre en utilisant la règle alphabétique de membre entrant."
    },
    "explicit_member": {
      "label": "Acheminé : membre explicite",
      "tooltip": "Ce SMS a été envoyé d'un flux membre-contexte, de sorte qu'il a été explicitement acheminé à ce membre."
    },
    "explicit_lead": {
      "label": "Acheminé: avance explicite",
      "tooltip": "Ce SMS a été envoyé d'un flux de prospect-contexte, de sorte qu'il a été explicitement acheminé à cette avance."
    },
    "single_match_member": {
      "label": "Routed: Cote unique"
    },
    "single_match_lead": {
      "label": "Routed: Coin simple"
    },
    "manual_outbound_selection": {
      "label": "Routed: Sélection manuelle"
    }
  },
  "communicationUnableToLoadSmsSettings": "Impossible de charger SMS paramètres",
  "communicationPleaseEnterInstructionsForWhatYouWantToSay": "Veuillez entrer des instructions pour ce que vous voulez dire.",
  "communicationUnableToGenerateDraftsRightNowPleaseTryAgain": "Impossible de générer des ébauches en ce moment. Veuillez réessayer.",
  "communicationRoutingSaved": "Routage enregistré",
  "communicationSmsInteractionIsNowLinkedToTheSelectedPerson": "SMS interaction est maintenant liée à la personne sélectionnée.",
  "communicationUnableToSaveRouting": "Incapable pour Enregistrer le routage",
  "communicationMissingRecipientPhone": "Téléphone du destinataire manquant",
  "communicationSelectAFromNumber": "Sélectionnez un numéro",
  "communicationPleaseChooseWhichClubNumberToSendFrom": "Veuillez choisir le numéro de club à envoyer.",
  "communicationSmsBlocked": "SMS bloqués",
  "communicationThisMemberHasOptedOutOfSms": "Ce membre a opté pour SMS.",
  "communicationThisMemberHasNotConsentedToSms": "Ce membre n'a pas consenti à SMS .",
  "communicationUnableToSendSmsAtThisTime": "Impossible d'envoyer SMS en ce moment.",
  "communicationProviderDidNotAcceptTheMessagePleaseTryAgain": "Le fournisseur n'a pas accepté le message. Veuillez réessayer.",
  "communicationSmsSent": "SMS envoyé",
  "communicationMessageSentChooseWhoThisSmsShouldBeLoggedAgainst": "Message envoyé. Choisissez qui ce SMS devrait être connecté.",
  "communicationYourMessageIsOnItsWay": "Votre message est en route.",
  "communication160Characters": "/160 caractères",
  "communicationFromNumber": "Nombre",
  "communicationLoadingNumbers": "Chargement des numéros...",
  "communicationSelectANumber": "Sélectionnez un numéro",
  "communicationNoSmsEnabledClubNumbersAreAvailableEnableSmsForADidInAdminVoipNumbers": "Aucun numéro du club compatible SMS n’est disponible. Activez les SMS pour un numéro DID dans Administration → Numéros VoIP.",
  "communicationDraftingAReply": "Rédaction d'une réponse...",
  "communicationSuggestedReply": "Réponse suggérée",
  "communicationUseReply": "Réponse",
  "communicationRegenerate": "Régénérer",
  "communicationCouldnTDraftReply": "Il ne pouvait pas rédiger de réponse.",
  "communicationWillSendViaTwilioSmsService": "Enverra via le service Twilio SMS",
  "communicationThisNumberBelongsToMultiplePeopleInPrivanaWhoWasThisSmsIntendedFor": "Ce nombre appartient à plusieurs personnes dans Privana . Qui était ce SMS prévu pour?",
  "communicationNoPhone": "Aucun téléphone",
  "communicationNoRoutingCandidatesAvailable": "Il n'y a pas de candidats à la relève.",
  "communicationDescribeWhatYouWantToSendThenReviewAndEditTwoDraftSmsOptions": "Décrivez ce que vous voulez envoyer, puis examinez et modifiez deux versions SMS.",
  "communicationInstruction": "Instruction",
  "communicationExampleRemindThemTheirTourIsTomorrowAt10AmAndAskThemToReplyIfTheyNeedToReschedule": "Exemple: Rappelez-leur leur visite est demain à 10 h et demandez-leur de répondre s'ils ont besoin de rééchelonner.",
  "communicationGeneratingOptions": "Des options de génération...",
  "communicationGenerateOptions": "Générer des options",
  "communicationOption1": "Option 1",
  "communicationOption2": "L ' option 2",
  "communicationUseThis": "Utilisez ceci",
  "communicationSmsThread": "Conversation SMS",
  "communicationViewAndReplyWithoutLeavingThisPage": "Voir et répondre sans laisser cette page.",
  "communicationUnableToLoadMessages": "Incapable de charger des messages.",
  "communicationLoadingMessages": "Chargement des messages...",
  "communicationNoMessagesInThisConversationYet": "Pas encore de messages dans cette conversation.",
  "communicationConversation": "Conversation",
  "communicationScrollToViewAllMessages": "Faites défiler tous les messages",
  "communicationNewEmail": "Nouveau courriel",
  "communicationAddAtLeastOneRecipientToForwardReply": "Ajouter au moins un bénéficiaire à l'avance/reply.",
  "communicationMessageCannotBeEmpty": "Le message ne peut être vide.",
  "communicationUnableToSendEmail": "Incapable d'envoyer un courriel",
  "communicationPleaseTryAgainInAMoment": "Veuillez réessayer dans un instant.",
  "communicationEmailSent": "Email envoyé",
  "communicationForwardSent": "Envoyé en",
  "communicationReplySent": "Réponse envoyée",
  "communicationDeliverySucceededMessageMetadataIsSyncing": "Les métadonnées de messages sont synchronisées.",
  "communicationMessageSent": "Message envoyé",
  "communicationSentSuccessfullyConversationRefreshIsStillSyncing": "Envoyé avec succès. Le rafraîchissement de la conversation est toujours en synchronisation.",
  "communicationEmailThread": "Fil d ' essai",
  "communicationLoadingConversation": "Chargement de conversation...",
  "communicationComposeANewEmailToStartAConversation": "Composez un nouveau courriel pour lancer une conversation.",
  "communicationNoConversationMessagesAvailable": "Aucun message de conversation n'est disponible.",
  "communicationYou": "Toi.",
  "communicationUnknownSender": "Inconnu sender",
  "communicationUnknownEmail": "E-mail inconnu",
  "communicationHideCcBcc": "Cacher CC/BCC",
  "communicationCcBcc": "CC/BCC",
  "communicationCc": "CC",
  "communicationBcc": "BCC",
  "communicationComposeEmail": "Composer email",
  "communicationComposeReply": "Composer la réponse",
  "communicationTone": "Ton",
  "communicationBrief": "Bref.",
  "communicationSyncingSent": "{status} . Synchronisation de l'objet envoyé...",
  "smsDelivery": {
    "queued": "Filed",
    "sending": "Envoi",
    "sent": "Envoyé",
    "delivered": "Livré",
    "failed": "Échec",
    "undelivered": "Non livrée",
    "scheduled": "Planifié"
  },
  "player": "Joueur",
  "profileChoices": {
    "female": "Féminin",
    "male": "Homme",
    "nonBinary": "Nonbinaire",
    "undisclosed": "Préférer de ne pas dire",
    "other": "Autre",
    "single": "Célibataire",
    "married": "Marié",
    "civilPartnership": "Partenariat civil",
    "partnered": "Partenaire",
    "separated": "Séparés",
    "divorced": "Divorcé",
    "widowed": "Veufs"
  }
};
